<div class="component-main-container">
  <app-page-header parentTitle="{{ 'report.reports-label' | translate }}"
    pageTitle="{{ 'report.generate-report-label' | translate }}">
  </app-page-header>

  @if (selectedInstallationsView) {
  <app-painel-fav [options]="selectedInstallations" [selectedOption]="selectedInstallations"></app-painel-fav>
  }

  <div class="row">
    <!-- Form Div -->
    <div class="col-lg-5 col-xl-4 col-md-12">
      <div class="component-forms-box">
        <!-- Formulário para geração de relatórios -->
        <div class="form-fields-box" [ngClass]="!genFormBox ? 'closed' : ''" [formGroup]="genForm">
          <h2 (click)="genFormBoxOpen()">
            {{ "report.create-form-title" | translate }}
          </h2>
          <hr [ngClass]="!genFormBox ? 'hr-open' : ''" />

          <!-- Passo de preencher refêrencia -->
          <div class="form-step">
            <app-circle-number stepNumber="1"></app-circle-number>
            <mat-form-field appearance="outline">
              <mat-label>{{ "report.report-name-reference" | translate}}</mat-label>
              <input matInput formControlName="referenceForm" name="referenceForm" type="text" />
            </mat-form-field>
          </div>

          <!-- Passo para selecionar o tipo de relatório -->
          <div class="form-step">
            <app-circle-number stepNumber="2"></app-circle-number>

            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "report.type-label" | translate }}</mat-label>

              <mat-select formControlName="reportTypeForm" name="reportTypeForm"
                (selectionChange)="showReportForm(selectReports.value)" #selectReports=matSelect>
                <mat-option value="alerts">{{
                  "report.general-alerts-label" | translate
                  }}</mat-option>
                <mat-option value="individualConsumption">{{
                  "report.consumption-label" | translate
                  }}</mat-option>
                <mat-option value="gatewayConsumption">{{
                  "report.gateway-consumption-label" | translate
                  }}</mat-option>
                <mat-option value="events">{{
                  "report.last-events-label" | translate
                  }}</mat-option>
                <mat-option value="status">{{
                  "report.individual-status-label" | translate
                  }}</mat-option>
                <mat-option value="lastTransmissions">{{
                  "report.last-transmission-label" | translate
                  }}</mat-option>
                <mat-option value="weather">{{
                  "report.weather-telemetry-report-label" | translate
                  }}</mat-option>
                <mat-option value="commands">{{
                  "report.commands-label" | translate
                  }}</mat-option>
                <mat-option value="installationsList">{{
                  "report.installations-label" | translate
                  }}</mat-option>
                <mat-option value="noTransmission">{{
                  "report.no-transmission-devices-label" | translate
                  }}</mat-option>
                <mat-option value="installationRecord">{{
                  "report.installation-logs-label" | translate
                  }}</mat-option>
                <mat-option value="installationManagement">{{
                  "report.installation-management-label" | translate
                  }}</mat-option>
                <mat-option value="latestData">{{
                  "report.last-data-label" | translate
                  }}</mat-option>
                <mat-option value="systemAlerts">{{
                  "report.system-alerts-label" | translate
                  }}</mat-option>
                <mat-option value="power">{{
                 "report.power-report-label" | translate
                  }}</mat-option>
                  <mat-option value="companyConsumption">{{
                  "report.company-consumption-label" | translate
                  }}</mat-option>
                @if (isIluminaSP) {
                <mat-option value="firstOnFirstOff">{{
                  "report.first-on-first-off-label" | translate
                  }}</mat-option>
                }
                @if (isIluminaSP) {
                <mat-option value="possibleStatus">{{
                  "report.possible-status-label" | translate
                  }}</mat-option>
                }

                <mat-option value="equipmentInstallation">{{ "report.equipment-installation-logs-label" | translate }}
                </mat-option>
                <!-- <mat-option value="networkConsumption">{{"report.network-consumption-label" | translate}}</mat-option>
                <mat-option value="userLogs">{{"report.user-logs-label" | translate}}</mat-option>
                <mat-option value="rele">{{"report.rele-label" | translate}}</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Caso onde é necessário escolher uma instalação -->
          <!-- Relatórios de Consumo, Eventos, Meteorológico -->
          @if (
          flagsGenForm.individualConsumption ||
          flagsGenForm.events ||
          flagsGenForm.status ||
          flagsGenForm.weather
          ) {
          <div>
            <!-- Campo para buscar a instalação -->
            <div class="form-step">
              <app-circle-number stepNumber="3"></app-circle-number>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{
                  "report.search-installation-label" | translate
                  }}</mat-label>
                <input (keydown.enter)="searchInstallation()" matInput formControlName="installationForm"
                  name="installationForm" type="text" />
                <button matSuffix mat-icon-button aria-label="Clear" class="component-search-icon-button"
                  (click)="searchInstallation()">
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>
            </div>
            @if (!isLoading && installations.length === 0) {
            <p class="text-danger">
              {{ "report.select_an_installation-label" | translate }}
            </p>
            }
            @if (isLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
            <!-- Campo para selecionar uma das instalações -->
            @if (isThereInstallationListed) {
            <div class="form-step">
              <app-circle-number stepNumber="4"></app-circle-number>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{
                  "report.select_an_installation-label" | translate
                  }}</mat-label>
                <mat-select formControlName="selectedInstallationForm" (selectionChange)="
                    installationSelected(selectInstallation.value)
                  " #selectInstallation>
                  @for (installation of installations; track installation) {
                  <mat-option [value]="installation">
                    {{ installation.reference }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
          }

          <!-- Campo para realizar a busca de concentradores -->
          @if (flagsGenForm.gatewayConsumption) {
          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{
                "installations.register-form-gateway" | translate
                }}</mat-label>
              <input matInput formControlName="gateway" #referenceGatewayCreate />
              <mat-icon class="component-search-icon" (click)="searchGateway(referenceGatewayCreate.value)">
                search
              </mat-icon>
            </mat-form-field>
          </div>
          }
          <!-- Loading -->
          @if (loadingGateway) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Campo que contém a lista de concentradores filtrados -->
          @if (gatewayList.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready">3.1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "installations.register-form-select-gateway" | translate }}
              </mat-label>
              <mat-select formControlName="gatewaySelected" (selectionChange)="gatewaySelected(selectedGateway.value)"
                #selectedGateway>
                @for (gateway of gatewayList; track gateway) {
                <mat-option [value]="gateway">
                  {{ gateway.reference }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Caso onde é necessário escolher mais de uma instalação -->
          <!-- Relatório de Alertas -->
          <!-- <div *ngIf="flagsGenForm.alerts"> -->
          <!-- Passo de preencher multipla instalação -->
          <!-- <div class="form-step">
            <app-circle-number stepNumber="3"></app-circle-number>

            <mat-form-field appearance="outline">
              <mat-label>{{
                "report.search-installation-label" | translate
              }}</mat-label>

              <input
                (keydown.enter)="searchMultiInstallation()"
                matInput
                formControlName="multiInstallationForm"
                name="multiInstallationForm"
                type="text"
                />

                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  class="component-search-icon-button"
                  (click)="searchMultiInstallation()"
                  >
                  <mat-icon>search</mat-icon>
                </button>
              </mat-form-field>
            </div> -->

          <!-- <p *ngIf="multiInstallations.length === 0" class="text-danger">
            {{ "report.select_an_installation-label" | translate }}
          </p>
          <p *ngIf="multiInstallations.length === 1">
            {{ multiInstallations.length }}
            {{ "report.one_installation_selected-label" | translate }}
          </p>
          <p *ngIf="multiInstallations.length > 1">
            {{ multiInstallations.length }}
            {{ "report.more_installations_selected-label" | translate }}
          </p>

          Passo para selecionar multiplas instalações
          <button
            *ngIf="multiInstallations.length > 0"
            (click)="searchMultiInstallation()"
            class="btn btn-primary mb-3"
            >
            Instalações selecionadas
          </button>
        </div> -->

          <!-- Caso onde é necessário escolher range de data -->
          <!-- Relatório de Comandos, Consumo, Eventos, Status e Meteorológico -->
          @if (
          flagsGenForm.commands ||
          flagsGenForm.individualConsumption ||
          flagsGenForm.companyConsumption ||
          flagsGenForm.events ||
          flagsGenForm.status ||
          flagsGenForm.weather ||
          flagsGenForm.alerts ||
          flagsGenForm.systemAlerts ||
          flagsGenForm.gatewayConsumption ||
          flagsGenForm.equipmentInstallation
          ) {
          <div class="form-step">
            @if (flagsGenForm.commands) {
            <app-circle-number stepNumber="3"></app-circle-number>

            } @else {
            @if (isThereInstallationListed) {
            <app-circle-number stepNumber="5"></app-circle-number>
            } @else {
            <app-circle-number stepNumber="4"></app-circle-number>
            }

            }
            <div class="date-picker-input">
              <p-datepicker selectionMode="range" [readonlyInput]="true" appendTo="body" dateFormat="dd/mm/yy"
                placeholder="{{ 'report.date-range-label' | translate }}" showIcon iconDisplay="input"
                formControlName="reportDateForm">
              </p-datepicker>
            </div>
          </div>

          }
          <!-- Relatório de Sem Transmissão -->
          @if (flagsGenForm.noTransmission) {
          <div>
            <mat-radio-group class="horizontal-radio-group">
              <mat-radio-button (click)="radioValue(1)">{{
                "report.no-transmission-devices-radio-period" | translate
                }}</mat-radio-button>
              <mat-radio-button (click)="radioValue(2)">{{
                "report.no-transmission-devices-radio-date" | translate
                }}</mat-radio-button>
            </mat-radio-group>
            <!-- Passo de preencher horas sem transmissão do relatório de sem transmissão -->
            <!-- Etapa que determina se por periodo -->
            @if (noTransmissionFlag === 1) {
            <div>
              <div class="form-step">
                <app-circle-number stepNumber="3"></app-circle-number>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{
                    "report.hours-without-transmission" | translate
                    }}</mat-label>
                  <input type="number" (keyup)="isHourStepConcluded()" formControlName="hoursForm" matInput />
                </mat-form-field>
              </div>
              <!-- erro para campo de sem transmissão -->
              @if (isHourError) {
              <div class="error-box">
                <p class="text-danger p-2">
                  {{ "report.please-enter-numbers-only" | translate }}
                </p>
              </div>
              }
            </div>
            }
            <!-- Etapa para decidir se é por data -->
            @if (noTransmissionFlag === 2) {
            <div>
              <div class="form-step">
                <app-circle-number stepNumber="3"></app-circle-number>
                <div class="date-picker-input">
                  <p-datepicker selectionMode="range" [readonlyInput]="true" appendTo="body" dateFormat="dd/mm/yy"
                    placeholder="{{ 'report.date-range-label' | translate }}" showIcon iconDisplay="input"
                    formControlName="reportDateForm"></p-datepicker>
                </div>
              </div>
            </div>
            }
          </div>
          }

          <!-- Relatório de Primeira mensagem de ligado e primeira mensagem de desligado -->
          @if (flagsGenForm.firstOnFirstOff) {
          <div>
            <div class="form-step">
              <app-circle-number stepNumber="3"></app-circle-number>
              <div class="date-picker-input">
                <p-datepicker formControlName="reportDateForm" dateFormat="dd/mm/yy" appendTo="body"
                  pInputMask="99/99/9999" placeholder="{{ 'report.date-label' | translate }}" />
              </div>
            </div>
          </div>
          }

          @if (flagsGenForm.possibleStatus) {
          <div>
            <div class="form-step">
              <app-circle-number stepNumber="3"></app-circle-number>
              <div class="date-picker-input">
                <p-datepicker formControlName="reportDateForm" dateFormat="dd/mm/yy" appendTo="body"
                  pInputMask="99/99/9999" placeholder="{{ 'report.date-label' | translate }}" />
              </div>
            </div>
          </div>
          }

          @if (flagsGenForm.power) {
          <div>
            <div class="form-step">
              <app-circle-number stepNumber="3"></app-circle-number>
              <div class="date-picker-input">
                <p-datepicker formControlName="reportDateForm" dateFormat="dd/mm/yy" appendTo="body"
                  pInputMask="99/99/9999" placeholder="{{ 'report.date-label' | translate }}" />
              </div>
            </div>
          </div>
          }

          <!-- Botão para reiniciar o formulário -->
          <div class="reset-form align-self-end">
            <button mat-stroked-button (click)="resetGenerationForm()">
              {{ "report.reset-form-label" | translate }}
            </button>
          </div>
          <!-- Botão para gerar relatório -->
          <button class="btn btn-success mb-2 w-100" (click)="generateReport()" [disabled]="!enableGenerateButton()">
            {{ "report.generate-report-label" | translate }}
          </button>
        </div>

        <!-- Formulário para filtro de relatórios -->
        <div class="form-fields-box" [ngClass]="!filterReportBox ? 'closed' : ''" [formGroup]="filterForm">
          <h2 (click)="filterReportBoxOpen()">
            {{ "report.filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filterReportBox ? 'hr-open' : ''" />

          <!-- Passo de preencher refêrencia -->
          <div class="form-step">
            <app-circle-number stepNumber="1"></app-circle-number>

            <mat-form-field appearance="outline">
              <mat-label>{{
                "report.report-name-reference" | translate
                }}</mat-label>

              <input matInput formControlName="referenceFilterForm" name="referenceFilterForm" type="text" />
            </mat-form-field>
          </div>

          <!-- Passo para selecionar o tipo de relatório -->
          <div class="form-step">
            <app-circle-number stepNumber="2"></app-circle-number>

            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>{{ "report.type-label" | translate }}</mat-label>

              <mat-select formControlName="reportTypeFilterForm" name="reportTypeFilterForm">
                <mat-option value="GENERAL_ALERTS">{{
                  "report.general-alerts-label" | translate
                  }}</mat-option>
                <mat-option value="GATEWAY_CONSUMPTION">{{
                  "report.gateway-consumption-label" | translate
                  }}</mat-option>
                <mat-option value="DEVICE_LAST_EVENTS">{{
                  "report.last-events-label" | translate
                  }}</mat-option>
                <mat-option value="INDIVIDUAL_STATUS">{{
                  "report.individual-status-label" | translate
                  }}</mat-option>
                <mat-option value="LAST_TRANSMISSION">{{
                  "report.last-transmission-label" | translate
                  }}</mat-option>
                <!-- <mat-option value="WEATHER_TELEMETRY">{{'weather_telemetry-label' | translate}}</mat-option> -->
                <mat-option value="COMMANDS">{{
                  "report.commands-label" | translate
                  }}</mat-option>
                <mat-option value="INSTALLATIONS">{{
                  "report.installations-label" | translate
                  }}</mat-option>
                  <mat-option value="POWER_REPORT">{{
                 "report.power-report-label" | translate
                  }}</mat-option>
                  <mat-option value="COMPANY_CONSUMPTION">{{
                  "report.company-consumption-label" | translate
                  }}</mat-option>
                <mat-option value="FIRST_ON_FIRST_OFF">{{
                  "report.first-on-first-off-label" | translate
                  }}</mat-option>
                <mat-option value="POSSIBLE_STATUS">{{
                  "report.possible-status-label" | translate
                  }}</mat-option>
                <mat-option value="LAST_DATA">{{
                  "report.last-data-label" | translate
                  }}</mat-option>
                <mat-option value="NO_TRANSMISSION_DEVICES">{{
                  "report.no-transmission-devices-label" | translate
                  }}</mat-option>
                <mat-option value="INSTALLATION_LOGS">{{
                  "report.installation-logs-label" | translate
                  }}</mat-option>
                <mat-option value="INSTALLATION_MANAGEMENT">{{
                  "report.installation-management-label" | translate
                  }}</mat-option>

                <mat-option value="EQUIPMENT_INSTALLATION_LOGS">{{
                  "report.equipment-installation-logs-label" | translate
                  }}</mat-option>
                <!-- <mat-option value="networkConsumption">{{"report.network-consumption-label" | translate}}</mat-option>
              <mat-option value="userLogs">{{"report.user-logs-label" | translate}}</mat-option>
              <mat-option value="rele">{{"report.rele-label" | translate}}</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Passo de preencher usuário -->
          <div class="form-step">
            <app-circle-number stepNumber="3"></app-circle-number>

            <mat-form-field appearance="outline">
              <mat-label>{{ "report.user-label" | translate }}</mat-label>

              <input matInput formControlName="userFilter" name="userFilter" type="text" />
            </mat-form-field>
          </div>

          <!-- Botão para reiniciar o formulário -->
          <div class="reset-form align-self-end">
            <button mat-stroked-button (click)="resetFilterForm()">
              {{ "report.reset-form-label" | translate }}
            </button>
          </div>

          <!-- Botão para filtrar os relatórios -->
          @if (!filterLoading) {
          <button class="btn btn-success mb-2 w-100" (click)="filterReport(null)">
            {{ "report.filter-label" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="false" [hasPDF]="false"></app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">

        <p-table [value]="ELEMENT_DATA" dataKey="id" [rows]="pageSize" [totalRecords]="length" [paginator]="true"
          (onPage)="pageChanged($event)" [showFirstLastIcon]="false" [showPageLinks]="false" [lazy]="true">

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference" style="width: 12rem"> {{ "report.reference-label" | translate }}</th>
              <th pSortableColumn="requestedBy" style="width: 12rem"> {{ "report.generator-by-label" | translate }}</th>
              <th pSortableColumn="reportType" style="width: 12rem"> {{ "report.type-label" | translate }}</th>
              <th pSortableColumn="ready" style="width: 12rem"> {{ "report.individual-status-label" | translate }}</th>
              <th pSortableColumn="generationDate" style="width: 12rem"> {{ "report.generator-date-label" | translate }}
              </th>
              <th pSortableColumn="actions" style="width: 12rem">{{ "report.action-label" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{ row.reference }}</td>
              <td>{{ row.requestedBy}}</td>
              <td>{{ getTranslationKey(row) | translate
                }}</td>
              <td>{{'report.reportStatus.' + row.ready |
                translate}}</td>
              <td>
                <span matTooltip="{{ 'time-zone-information-label' | translate }}" matTooltipPosition="above">
                  {{ formatDate(row.generationDate) }}
                </span>
              </td>
              <td>
                <div>
                  @switch (row.ready) {
                  @case (1) {
                  <p-button styleClass="btn-actions" icon="pi pi-download" class="mr-2" [rounded]="true"
                    (click)="downloadReport(row.id, row.reference)" title="{{ 'report.title-label-download' | translate }}" />

                  @if (row.ready == 1) {

                  <p-button styleClass="btn-warn" icon="pi pi-trash" [rounded]="true" class="mr-2"
                    (click)="deleteReport(row.id)" title="{{ 'report.title-label-delete-report' | translate }}" />
                  }
                  }
                  @case (0) {
                  <p-button severity="warn" icon="pi pi-times-circle" [rounded]="true" class="mr-2" [outlined]="true"
                    (click)="deleteReport(row.id)" title="{{ 'report.title-label-cancel-report' | translate }}"
                    label="{{ 'report.download-unavailable-label' | translate }}" iconPos="top" />
                  }
                  @case (3) {
                  <p-button severity="danger" icon="pi pi-times-circle" [rounded]="true" class="mr-2" [outlined]="true"
                    (click)="deleteReport(row.id)" title="{{ 'report.title-label-cancel-report' | translate }}"
                    label="{{ 'report.failed-report-generation' | translate }}" iconPos="top" />
                  }
                  }
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</div>
